import React from 'react';

export default function HowItWorks({ lang }) {
  const stepsEn = [
    { num: '01', title: 'Buy The Pass', desc: 'Secure your spot before they sell out.' },
    { num: '02', title: 'Show Your Phone', desc: 'Flash your digital pass to the bartender.' },
    { num: '03', title: 'Get A Beer', desc: 'Order your first beer at the bar.' },
    { num: '04', title: 'GET THE 2ND FREE', desc: 'Show the pass. Your second beer is 100% free.' },
  ];

  const stepsEs = [
    { num: '01', title: 'Compra El Pase', desc: 'Asegura tu lugar antes de que se agoten.' },
    { num: '02', title: 'Muestra Tu Celular', desc: 'Muestra tu pase digital al bartender.' },
    { num: '03', title: 'Recibe Una Cerveza', desc: 'Pide tu primera cerveza en la barra.' },
    { num: '04', title: 'LA 2DA ES GRATIS', desc: 'Muestra tu pass. Tu segunda cerveza es 100% gratis.' },
  ];

  const steps = lang === 'en' ? stepsEn : stepsEs;

  return (
    <section className="w-full py-12">
      <h2 className="text-4xl sm:text-5xl font-black uppercase mb-8 text-amber-400 bg-white text-black inline-block px-4 py-2 transform -rotate-2 border-2 border-white">
        {lang === 'en' ? 'How It Works' : 'Cómo Funciona'}
      </h2>
      
      <div className="flex flex-col gap-6">
        {steps.map((step) => (
          <div key={step.num} className="flex gap-4 sm:gap-6 items-start bg-zinc-900 p-4 border-2 border-zinc-800">
            <span className="text-4xl sm:text-5xl font-black text-amber-400 shrink-0">
              {step.num}
            </span>
            <div>
              <h3 style={{
      color: 'rgb(245, 244, 244)'
    }} className="text-xl sm:text-2xl font-black uppercase">{step.title}</h3>
              <p className="text-gray-400 font-bold mt-1 text-sm sm:text-base uppercase">{step.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}